import { useState } from "react";
import { Link } from "react-router-dom";
import { firestore, auth } from "../firebase";
import firebase from "firebase/compat/app";
import { useUserProvider } from "../context/UserProvider";

import {
  Card,
  CardContent,
  Button,
  TextField,
  Stack,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Grid,
  Typography,
} from "@mui/material";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { SelectChangeEvent } from "@mui/material/Select";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify"; // then this

const AddSite = () => {
  const history = useHistory();
  const [siteStreet, setSiteStreet] = useState("");
  const [siteStreetError, setSiteStreetError] = useState(false);
  const [siteNumber, setSiteNumber] = useState("");
  const [siteNumberError, setSiteNumberError] = useState(false);
  const [siteHousingType, setSiteHousingType] = useState("");
  const [siteHousingTypeError, setSiteHousingTypeError] = useState(false);
  const [sitePostalCode, setSitePostalCode] = useState("");
  const [siteConstructionYear, setSiteConstructionYear] = useState("");
  const [siteNotes, setSiteNotes] = useState("");
  const [siteMunicipality, setSiteMunicipality] = useState("");

  const [clientCompany, setClientCompany] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [clientFirstName, setClientFirstName] = useState("");
  const [clientLastName, setClientLastName] = useState("");
  const [clientTelephone, setClientTelephone] = useState("");

  const [entrepreneurCompany, setEntrepreneurCompany] = useState("");
  const [entrepreneurCompanyNumber, setEntrepreneurCompanyNumber] =
    useState("");
  const [entrepreneurEmail, setEntrepreneurEmail] = useState("");
  const [entrepreneurFirstName, setEntrepreneurFirstName] = useState("");
  const [entrepreneurLastName, setEntrepreneurLastName] = useState("");
  const [entrepreneurTelephone, setEntrepreneurTelephone] = useState("");

  const { user } = useUserProvider();
  const { uid, displayName, email, photoURL } = auth.currentUser || {};

  const handleSubmit = (e) => {
    e.preventDefault();
    if (siteStreet && siteNumber && siteHousingType) {
      const newSite = {
        clientCompany,
        clientEmail,
        clientFirstName,
        clientLastName,
        clientTelephone,
        entrepreneurCompany,
        entrepreneurCompanyNumber,
        entrepreneurEmail,
        entrepreneurFirstName,
        entrepreneurLastName,
        entrepreneurTelephone,
        siteConstructionYear,
        siteHousingType,
        siteMunicipality,
        siteNotes,
        siteNumber,
        sitePostalCode,
        siteStreet,
        user: {
          uid,
          displayName,
          email,
          photoURL,
        },
        favorites: 0,
        comments: 0,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      };

      firestore.collection("sites").add(newSite);

      setClientCompany("");
      setClientEmail("");
      setClientFirstName("");
      setClientLastName("");
      setClientTelephone("");
      setEntrepreneurCompany("");
      setEntrepreneurCompanyNumber("");
      setEntrepreneurEmail("");
      setEntrepreneurFirstName("");
      setEntrepreneurLastName("");
      setEntrepreneurTelephone("");
      setSiteConstructionYear("");
      setSiteHousingType("");
      setSiteMunicipality("");
      setSiteNotes("");
      setSiteNumber("");
      setSitePostalCode("");
      setSiteStreet("");
      // Alert.success("Post Created Successfully");
      history.push("/dashboard");
      toast.success("Site created successfully", {
        theme: "colored",
      });
    } else {
      // Alert.error("Plzzz Fill All Fields");

      toast.error("Please complete the required fields", {
        theme: "colored",
      });
    }

    setSiteStreetError(false);
    setSiteNumberError(false);
    setSiteHousingTypeError(false);
    if (siteStreet == "") {
      setSiteStreetError(true);
    }
    if (siteNumber == "") {
      setSiteNumberError(true);
    }
    if (siteHousingType == "") {
      setSiteHousingTypeError(true);
    }
  };
  return (
    // <form onSubmit={handleSubmit} noValidate autoComplete="off">
    <form onSubmit={handleSubmit}>
      <Card sx={{ marginBottom: "30px" }}>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h6">Site informations</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  error={siteStreetError}
                  type="text"
                  name="Site Street"
                  label="Site Street"
                  placeholder="Site Street"
                  value={siteStreet}
                  // onChange={(e) => setTitle(e)}
                  onChange={(e) => setSiteStreet(e.target.value)}
                />
                <TextField
                  fullWidth
                  error={siteNumberError}
                  type="number"
                  name="Street number"
                  label="Street number"
                  placeholder="Street number"
                  value={siteNumber}
                  // onChange={(e) => setTitle(e)}
                  onChange={(e) => setSiteNumber(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="number"
                  name="Postal code"
                  label="Postal code"
                  placeholder="Postal code"
                  value={sitePostalCode}
                  // onChange={(e) => setTitle(e)}
                  onChange={(e) => setSitePostalCode(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="text"
                  name="Municipality"
                  label="Municipality"
                  placeholder="Municipality"
                  value={siteMunicipality}
                  // onChange={(e) => setTitle(e)}
                  onChange={(e) => setSiteMunicipality(e.target.value)}
                />
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Housing Type
                  </InputLabel>
                  <Select
                    fullWidth
                    error={siteHousingTypeError}
                    labelId="demo-simple-select-label"
                    label="Housing Type"
                    id="demo-simple-select"
                    value={siteHousingType}
                    // onChange={handleChange}
                    onChange={(e) => setSiteHousingType(e.target.value)}
                  >
                    <MenuItem value="House">House</MenuItem>
                    <MenuItem value="Appartment">Appartment</MenuItem>
                    <MenuItem value="Office">Office</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  type="number"
                  name="Year of construction"
                  label="Year of construction"
                  placeholder="Year of construction"
                  value={siteConstructionYear}
                  // onChange={(e) => setTitle(e)}
                  onChange={(e) => setSiteConstructionYear(e.target.value)}
                />
                {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    views={["year"]}
                    label="Year of construction"
                    value={siteConstructionYear}
                    onChange={(e) => setSiteConstructionYear(e.target.value)}
                    renderInput={(params) => (
                      <TextField {...params} helperText={null} />
                    )}
                  />
                </LocalizationProvider> */}

                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Additional Notes"
                  multiline
                  rows={4}
                  // defaultValue="Additional Notes"
                  onChange={(e) => setSiteNotes(e.target.value)}
                />
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Card sx={{ marginBottom: "30px" }}>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h6">Client informations</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  type="text"
                  name="Client firstname"
                  label="Firstname"
                  placeholder="Firstname"
                  value={clientFirstName}
                  // onChange={handleChange}
                  onChange={(e) => setClientFirstName(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="text"
                  name="Client lastname"
                  label="Lastname"
                  placeholder="Lastname"
                  value={clientLastName}
                  // onChange={handleChange}
                  onChange={(e) => setClientLastName(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="text"
                  name="Client company"
                  label="Company name"
                  placeholder="Company name"
                  value={clientCompany}
                  // onChange={(e) => setTitle(e)}
                  onChange={(e) => setClientCompany(e.target.value)}
                />
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  type="email"
                  name="Client email"
                  label="Email address"
                  placeholder="Email address"
                  value={clientEmail}
                  // onChange={(e) => setTitle(e)}
                  onChange={(e) => setClientEmail(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="number"
                  name="Client phone number"
                  label="Phone number"
                  placeholder="Phone number"
                  value={clientTelephone}
                  // onChange={(e) => setTitle(e)}
                  onChange={(e) => setClientTelephone(e.target.value)}
                />
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Card sx={{ marginBottom: "30px" }}>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h6">Entrepreneur informations</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  type="text"
                  name="Entrepreneur Firstname"
                  label="Firstname"
                  placeholder="Firstname"
                  value={entrepreneurFirstName}
                  // onChange={(e) => setTitle(e)}
                  onChange={(e) => setEntrepreneurFirstName(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="text"
                  name="Entrepreneur Lastname"
                  label="Lastname"
                  placeholder="Lastname"
                  value={entrepreneurLastName}
                  // onChange={(e) => setTitle(e)}
                  onChange={(e) => setEntrepreneurLastName(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="text"
                  name="Entrepreneur company"
                  label="Company name"
                  placeholder="Company name"
                  value={entrepreneurCompany}
                  // onChange={(e) => setTitle(e)}
                  onChange={(e) => setEntrepreneurCompany(e.target.value)}
                />
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  type="text"
                  name="Entrepreneur company number"
                  label="Company number"
                  placeholder="Company number"
                  value={entrepreneurCompanyNumber}
                  // onChange={(e) => setTitle(e)}
                  onChange={(e) => setEntrepreneurCompanyNumber(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="email"
                  name="Entrepreneur email"
                  label="Email address"
                  placeholder="Email address"
                  value={entrepreneurEmail}
                  // onChange={(e) => setTitle(e)}
                  onChange={(e) => setEntrepreneurEmail(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="number"
                  name="Entrepreneur phone number"
                  label="Phone number"
                  placeholder="Phone number"
                  value={entrepreneurTelephone}
                  // onChange={(e) => setTitle(e)}
                  onChange={(e) => setEntrepreneurTelephone(e.target.value)}
                />
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Grid align="right">
        <Button variant="contained" size="large" type="submit">
          Create
        </Button>
      </Grid>
    </form>
  );
};

export default AddSite;
